var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "241px",
    height: "43px",
    viewBox: "0 0 399 43",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "JDH\u5065\u5EB7\u5185\u5F00\u653E\u5E73\u53F0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fontFamily: "JDLANGZHENGTI--GB1-0, JDLangZhengTi",
    fontSize: 40,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01\\u767B\\u5F55",
    transform: "translate(-60.000000, -41.000000)",
    fill: "#266CEE",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("text", {
    id: "JDH\\u5065\\u5EB7\\u5185\\u5F00\\u653E\\u5E73\\u53F0"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 60,
    y: 76
  }, "JDH\u5065\u5EB7\u5185\u5F00\u653E\u5E73\u53F0"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6b8faa58.svg";
export { ForwardRef as ReactComponent };